import CONSTS from '../../constants/actions';

const initialState = {
  roles: [],
  totalPermissions: 0,
  totalCount: 0,
  limit: 0,
  offset: 0,
  hasMore: false,
};

const rolesReducer = (state, action) => {
  switch (action.status) {
    case 'success':
      return { ...action.data };
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CONSTS.FETCH_ROLES:
      return rolesReducer(state, action);
    default:
      return state;
  }
};
